import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=416c3214&"
import script from "./Totals.vue?vue&type=script&lang=js&"
export * from "./Totals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416c3214')) {
      api.createRecord('416c3214', component.options)
    } else {
      api.reload('416c3214', component.options)
    }
    module.hot.accept("./Totals.vue?vue&type=template&id=416c3214&", function () {
      api.rerender('416c3214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/Totals.vue"
export default component.exports